import { render, staticRenderFns } from "./Aries.vue?vue&type=template&id=72b939a4"
import script from "./Aries.vue?vue&type=script&lang=js"
export * from "./Aries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports